
import { Table, Stack, TableBody, Checkbox, TableCell, FormControl, TableContainer, TableHead, TableRow, IconButton, Collapse, Tabs, Tab, Box, Divider, Grid, Typography, Tooltip, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar } from "@mui/material";

import { styled } from '@mui/material/styles';

import React, { useState, useEffect, useRef } from "react";

import PropTypes from 'prop-types';
import Header from "../../../Layout/Header";


import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import CallAlertBar from "../../../Layout/Alertbar";
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GlobalConfig from "../../../components/GlobalConfig";
import { useTranslation } from "react-i18next";
import useStoreLedgerList from "../../../hooks/useStoreLedgerList";
import useStoreLedgerTransactionList from "../../../hooks/useStoreLedgerTransactionList";
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { tokens } from "../../../theme/theme";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const AddStoreLedger = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const [selectedRows, setSelectedRows] = useState([]);
    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;

    const [selectedMaterialID, setSelectedMaterialID] = useState('');

    // List of Parameter
    const [filterFromDate, setFilterFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [filterToDate, setFilterToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const { ledgerList, setLedgerList, loadLedgerListByDateRange, } = useStoreLedgerList()
    const { ledgerTransList, setLedgerTransList, loadLedgerListByMaterial, } = useStoreLedgerTransactionList(selectedMaterialID);


const [materialFilter, setMaterialFilter] = useState(null);

    const [selectedStatus, setSelectedStatus] = useState('All');

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });

    const callback = () => {
        handleBackWinderMachineEntry();
    }

    const callMessage = (serverityval, msg, title) => {
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };

    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        date: '',
        purchaseOrder: '',
        partyName: '',
        status: '',
        received: '',
        billed: '',
        amount: '',
        expectedDeliveryDate: '',
    });


    // const filteredData = ledgerList.filter((row) => {
    //     // Check if row matches selected status
    //     if (selectedStatus === 'All' || row.status === selectedStatus) {
    //         // Check if all filter fields match
    //         return Object.keys(filters).every((key) => {
    //             if (filters[key] === '') return true; // No filter applied
    //             return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
    //         });
    //     }
    //     return false;
    // });
const filteredData = ledgerList.filter((row) => {
  // Material-wise filter
  if (materialFilter && row.id_material !== materialFilter.id_material) {
    return false;
  }

  // Status filter (existing)
  if (selectedStatus !== 'All' && row.status !== selectedStatus) {
    return false;
  }

  // Other column filters
  return Object.keys(filters).every((key) => {
    if (filters[key] === '') return true;
    return String(row[key])
      .toLowerCase()
      .includes(filters[key].toLowerCase());
  });
});


    const [expandedRow, setExpandedRow] = useState(null);  // Track which row is expanded
    const [expandedData, setExpandedData] = useState({});

    const handleExpandRow = async (row) => {
        const { id_material } = row;
        // Toggle expansion
        if (expandedRow === id_material) {
            setExpandedRow(null);
            return;
        }
        setSelectedMaterialID(id_material);


        // try {


        //     setExpandedData((prev) => ({ ...prev, [id_material]: ledgerTransList }));
        //     setExpandedRow(id_material);


        // } catch (error) {
        //     console.error("Failed to fetch expanded row data", error);
        // }

    };

    useEffect(() => {

        setExpandedData((prev) => ({ ...prev, [selectedMaterialID]: ledgerTransList }));
        setExpandedRow(selectedMaterialID);
    }, [ledgerTransList]); // also re-fetch when selectedID changes



    return (<>


        <Box padding={0}>

            <Header title={'Stock Ledger'} subtitle="" callback={callback} />
            <Divider />
            <Grid container spacing={2} padding="10px 20px">
                 {/* Typography label using theme defaults */}
  <Grid item xs={12} sm={3} md={2}>
    <Typography variant="h6">Material Name / Code</Typography>
      
  </Grid>
  <Grid item xs={12} sm={6} md={4}>
    <Autocomplete
      size="small"
      options={ledgerList}
      value={materialFilter}
      onChange={(e, newValue) => setMaterialFilter(newValue)}
      getOptionLabel={(option) =>
        `${option.material_code} - ${option.material_name}`
      }
      renderInput={(params) => (
        <TextField
          {...params}
          //label="Material Name / Code"
          placeholder="Select Material"
          size="small"
          fullWidth
        />
      )}
    />
  </Grid>
</Grid>


            <CallAlertBar
                parentRollMsgOpen={parentRollMsgOpen}
                setParentRollMsgOpen={setParentRollMsgOpen}
                parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue}
                parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue}
                parentRollMessageValue={parentRollMessageValue}
                setParentRollMessageValue={setParentRollMessageValue} />

            {/* <Grid container padding="10px 0px 5px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                    <Typography variant="h6" > {t('prod_winder_machine.filter_by')}
                        <CustomTooltip
                            title={
                                <span>
                                    <b>The data has been filtered based on the parent roll, created shift date.</b> <br />
                                </span>}
                        >
                            <IconButton sx={{ marginLeft: "5px" }}>
                                <InfoOutlinedIcon sx={{ color: colors.redAccent[500], fontSize: "16px" }} />
                            </IconButton>
                        </CustomTooltip> </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={1.7} lg={1.7} xl={1.7}>
                    <FormControl fullWidth size="small">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                style={{ marginLeft: '10px' }}
                                id="FromDate"
                                value={dayjs(filterFromDate)}
                                // onChange={(date) => handleFilterFromDate(date)}
                                slotProps={{ textField: { size: 'small', } }}
                                renderInput={(props) => <TextField {...props} />}
                                autoFocus
                                format="DD-MMM-YYYY"
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>



                <Grid item xs={12} sm={12} md={1.7} lg={1.7} xl={1.7}>
                    <FormControl fullWidth size="small" >
                        <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                            <DatePicker
                                id="ToDate"
                                value={dayjs(filterToDate)}
                                format="DD-MMM-YYYY"
                                // onChange={(date) => handleFilterToDate(date)}
                                slotProps={{ textField: { size: 'small', } }}
                                renderInput={(props) => <TextField {...props} />}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>

            </Grid> */}


            <ResponsiveBox customMaxHeight={{
                xs: '72vh', // Extra small devices (phones)
                sm: '72vh', // Small devices (tablets)
                md: '74vh', // Medium devices (small laptops)
                lg: '74vh', // Large devices (desktops)
                xl: '82vh', // Extra large devices (large desktops)
            }}>

                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        <Table size="small">
                            <TableHead sx={{ height: 10 }}>
                                <TableRow>

                                    <TableCell>MATRIAL CODE</TableCell>
                                    <TableCell>DESCRIPTION</TableCell>
                                    {/* <TableCell>FINANCIAL YEAR</TableCell> */}
                                    <TableCell>OPENING BALANCE</TableCell>
                                    <TableCell>RECEVIED QUANTITY</TableCell>
                                    <TableCell>ISSUED QUANTITY</TableCell>
                                    <TableCell>CLOSING QUANTITY</TableCell>
                                    <TableCell>UOM</TableCell>
                                    <TableCell>AGE OF STOCK</TableCell>
                                    <TableCell>ACTION</TableCell>
                                    <TableCell>
                                        {/* <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton> */}
                                        {/* <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                <TextField
                                                    label="Date"
                                                    name="date"
                                                    value={filters.date}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />                                           
                                               
                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                            </Box>
                                        </Modal> */}
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row) => (
                                    <React.Fragment key={row.id_material}>
                                        <TableRow key={row.id_store_ledger}>
                                            <TableCell  align="center">{row.material_code}</TableCell>
                                            <TableCell  align="center">
                                                <span
                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                // onClick={() => handleCallEdit(row.id)}
                                                >
                                                    {row.material_name}
                                                </span>
                                            </TableCell>
                                            {/* <TableCell>{row.financial_year}</TableCell> */}
                                            <TableCell align="center">{row.openning_quantity}</TableCell>
                                            <TableCell  align="center">{row.received_quantity}</TableCell>
                                            <TableCell  align="center">{row.issued_quantity}</TableCell>
                                            <TableCell  align="center">{row.closing_quantity}</TableCell>
                                            <TableCell  align="center">{row.material_uom}</TableCell>
                                            <TableCell  align="center">{row.age_of_stock_days}</TableCell>
                                            <TableCell>
                                                <Tooltip title="Stock Ledger Transactions">
                                                    <IconButton onClick={() => handleExpandRow(row)}>
                                                        {expandedRow === row.id_material ? <ExpandLess style={{ color: 'teal', fontSize: "16px", fontWeight: "bold" }} /> : <ExpandMore style={{ color: 'teal', fontSize: "16px", fontWeight: "bold" }} />}
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                            {/* <TableCell>{row.received === 'Yes' ? (
                                            <Tooltip title="Received">
                                                <FiberManualRecordIcon sx={{ fontSize: '12px', color: '#1de9b6' }} />
                                            </Tooltip>

                                        ) : (
                                            <Tooltip title="Not Received">
                                                <FiberManualRecordIcon sx={{ fontSize: '12px', color: '#616161' }} />
                                            </Tooltip>
                                        )}</TableCell>
                                        <TableCell>{row.billed === 'Yes' ? (
                                            <Tooltip title="Billed">
                                                <FiberManualRecordIcon sx={{ fontSize: '12px', color: '#1de9b6' }} />
                                            </Tooltip>
                                        ) : (
                                            <Tooltip title="Not Billed">
                                                <FiberManualRecordIcon sx={{ fontSize: '12px', color: '#616161' }} />
                                            </Tooltip>

                                        )}</TableCell> */}

                                        </TableRow>


                                        {/* Expanded Row */}
                                        {expandedRow === row.id_material && (
                                            <TableRow>
                                                <TableCell colSpan={8} style={{ padding: 0 }}>
                                                    <Collapse in={expandedRow === row.id_material} timeout="auto" unmountOnExit>
                                                        <Box margin={1}>
                                                            {/* Expanded Data in Table Format */}
                                                            {expandedData[row.id_material] ? (
                                                                <Table size="small" aria-label="expanded-data">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell></TableCell>
                                                                            <TableCell>TRANSACTION DATE</TableCell>
                                                                            <TableCell sx={{ textAlign: "center", }}>DOCUMENT NO.</TableCell>
                                                                            <TableCell sx={{ textAlign: "center", }}>TRANSACTION QUANTITY</TableCell>
                                                                            <TableCell sx={{ textAlign: "center", }}>REMARKS</TableCell>
                                                                            <TableCell sx={{ textAlign: "center", }}>DOCUMENT TYPE</TableCell>
                                                                            <TableCell sx={{ textAlign: "center", }}>TRANSACTION TYPE</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {expandedData[row.id_material].map((item, index) => (
                                                                            <TableRow key={index}>
                                                                                <TableCell>{index + 1}</TableCell>

                                                                                <TableCell>{item.txn_date ? dayjs(item.txn_date).format('DD-MMM-YYYY') : ''}</TableCell>
                                                                                <TableCell >{item.doc_reference}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{item.quantity}</TableCell>
                                                                                <TableCell >{item.remarks}</TableCell>
                                                                                <TableCell >{item.doc_type}</TableCell>
                                                                                <TableCell >{item.txn_type}</TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                            ) : (
                                                                "Loading..."
                                                            )}
                                                        </Box>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTableContainer>
            </ResponsiveBox>
        </Box>
    </>)
}
export default AddStoreLedger;